var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bobble"},[_c('div',{staticClass:"fill",style:({top: _vm.top, height: _vm.height})}),_c('img',{staticClass:"mask",attrs:{"src":"/images/economy/bobble_mask.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }